// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.droppable-container {
  border-color: #b8b8b8;
  border-width: 1px;
  min-height: 100px;
  padding: 20px;
  position: relative;
  border-radius: 8px;
}

.column-delete {
  position: absolute;
  top: -12px;
  right: -12px;
  font-size: 1.2rem;
  font-weight: 200;
  cursor: pointer;
  display: none;
  color: #5b5b5b;
}

.column-delete:hover {
  color: #d90909;
}

.droppable-container:hover .column-delete {
  display: block;
}

.row-title {
  font-weight: 500;
  font-size: 13px;
  border: none;
  padding-left: 0;
}

.editable {
  display: none !important;
}

.draggable-item:hover .editable {
  display: flex !important;
}

.droppable-drag-over {
  border: 1px solid #000;
  background: aliceblue;
}

.setting-container {
  position: relative;
  display: none;
  top: -35px;
  right: -25px;
  background: white;
}

.droppable-list {
  border: 1px dotted grey;
}

.setting-menu-item {
  padding: 5px;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
  text-align: center;
}

.setting-menu-item:hover {
  background: #b9b9b9;
}

.droppable-list:hover .setting-container {
  display: block;
  z-index: 9999;
  transition: all 0.5s ease-in-out;
}

.setting-text {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: start;
  gap: 5px;
  border-bottom: 1px solid #d3d3d3;
  padding: 5px 10px;
}

.setting-text:hover {
  color: #5b5b5b;
}

.dnd-placeholder {
  font-size: 13px;
  text-align: center;
  font-weight: 100;
  color: #636363;
  padding-top: 15px;
}

@media (min-width: 1024px) {
  .row-title, .dnd-placeholder {
    font-size: 11px;
  }
}
@media (min-width: 1366px) {
  .dnd-placeholder {
    font-size: 13px;
  }
}
@media (min-width: 1920px) {
  .row-title, .dnd-placeholder {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/DynamicForm/components/formbuilder/DroppableList.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,sBAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,gCAAA;AACF;;AAEA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,QAAA;EACA,gCAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE;IACE,eAAA;EACF;AACF;AAGA;EACE;IACE,eAAA;EADF;AACF;AAIA;EACE;IACE,eAAA;EAFF;AACF","sourcesContent":[".droppable-container {\n  border-color: #b8b8b8;\n  border-width: 1px;\n  min-height: 100px;\n  padding: 20px;\n  position: relative;\n  border-radius: 8px;\n}\n\n.column-delete {\n  position: absolute;\n  top: -12px;\n  right: -12px;\n  font-size: 1.2rem;\n  font-weight: 200;\n  cursor: pointer;\n  display: none;\n  color: #5b5b5b;\n}\n\n.column-delete:hover {\n  color: #d90909;\n}\n\n.droppable-container:hover .column-delete {\n  display: block;\n}\n\n.row-title {\n  font-weight: 500;\n  font-size: 13px;\n  border: none;\n  padding-left: 0;\n}\n\n.editable {\n  display: none !important;\n}\n\n.draggable-item:hover .editable {\n  display: flex !important;\n}\n\n.droppable-drag-over {\n  border: 1px solid #000;\n  background: aliceblue;\n}\n\n.setting-container {\n  position: relative;\n  display: none;\n  top: -35px;\n  right: -25px;\n  background: white;\n}\n\n.droppable-list {\n  border: 1px dotted grey;\n}\n\n.setting-menu-item {\n  padding: 5px;\n  cursor: pointer;\n  border-bottom: 1px solid #ccc;\n  text-align: center;\n}\n\n.setting-menu-item:hover {\n  background: #b9b9b9;\n}\n\n.droppable-list:hover .setting-container {\n  display: block;\n  z-index: 9999;\n  transition: all 0.5s ease-in-out;\n}\n\n.setting-text {\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  align-items: start;\n  justify-content: start;\n  gap: 5px;\n  border-bottom: 1px solid #d3d3d3;\n  padding: 5px 10px;\n}\n\n.setting-text:hover {\n  color: #5b5b5b;\n}\n\n.dnd-placeholder {\n  font-size: 13px;\n  text-align: center;\n  font-weight: 100;\n  color: #636363;\n  padding-top: 15px;\n}\n\n@media (min-width: 1024px) {\n  .row-title, .dnd-placeholder {\n    font-size: 11px;\n  }\n}\n\n\n@media (min-width: 1366px) {\n  .dnd-placeholder {\n    font-size: 13px;\n  }\n}\n\n@media (min-width: 1920px) {\n  .row-title, .dnd-placeholder {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
